// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a[data-v-173e65fd] {\n  margin-bottom: 0.75em;\n  display: block;\n  color: var(--carbon-900);\n}\na i[data-v-173e65fd] {\n  color: var(--brand-600);\n}\na[data-v-173e65fd]:hover {\n  color: var(--carbon-900);\n}", ""]);
// Exports
module.exports = exports;
